import React from "react";
import styles from "./SubHeading.module.css"

const SubHeading = ({ text }) => {
    return <h5 className={styles.h5}>{text}</h5>;
};

export default SubHeading;
